import { CheckIcon } from '@heroicons/react/outline';
import Image from 'next/image';
import Link from 'next/link';

const tiers = [
  {
    id: 'tier-mol',
    name: 'Mól Książkowy',
    href: '/auth/login',
    price: 0,
    amount: '100 kodów',
    description: 'Załóż darmowe konto i kataloguj książki szybko i profesjonalnie.',
    features: [
      '1000 kodów do wygenerowania',
      'Dostęp do mapy bibliofili w okolicy',
      'Kontrola własnej biblioteczki',
      'Eksportowanie do Exela i CSV',
      'Oznaczanie egzemplarzy do pożyczenia',
      'Prywatne, niewidoczne na mapie półki',
      'Wyszukiwanie tytułów oraz duplikatów',
    ],
    button: 'Załóż konto',
  },
  {
    id: 'tier-librarian',
    name: 'Bibliotekarz',
    href: '/contact',
    price: 15,
    amount: '100 samoprzylepnych kodów',
    description:
      'Chcesz skatalogować okolicę? Gromadzisz pokaźne zbiory? Masz antykwariat i potrzebujesz obecności w internecie? To pakiet dla Ciebie.',
    features: ['Paczka 100 gotowych samoprzylepnych etykiet', 'Dodawanie publicznych recenzji'],
    button: 'Kup',
  },
];

export default function PriceTier() {
  return (
    <div className="bg-gray-900">
      <div className="relative overflow-hidden pt-32 pb-96 lg:pt-40">
        <div>
          <Image
            className="absolute bottom-0 left-1/2 w-[1440px] max-w-none"
            src={require('@/assets/images/shelf-background.webp')}
            alt="Tło z półkami książek"
            fill
          />
        </div>
        <div className="relative mx-auto max-w-7xl px-6 text-center lg:px-8">
          <div className="mx-auto max-w-2xl lg:max-w-4xl">
            <h2 className="text-lg font-semibold leading-8 text-yellow-400">Pakiety</h2>
            <p className="mt-2 text-4xl font-bold tracking-tight text-white">
              Zróżnicowane zestawy, <br className="hidden sm:inline lg:hidden" />
              dla Twoich potrzeb
            </p>
            {/* <p className="mt-6 text-lg leading-8 text-white/60">
              Jeśli nie pasujesz to tych kategorii nie martw się - napisz w celu dostosowania oferty.
            </p> */}
          </div>
        </div>
      </div>
      <div className="flow-root bg-white pb-32 lg:pb-40">
        <div className="relative -mt-80">
          <div className="relative z-10 mx-auto max-w-7xl px-6 lg:px-8">
            <div className="mx-auto grid max-w-md grid-cols-1 gap-8 lg:max-w-4xl lg:grid-cols-2 lg:gap-8">
              {tiers.map((tier) => (
                <div
                  key={tier.name}
                  className="flex flex-col rounded-3xl bg-white shadow-xl ring-1 ring-black/10"
                >
                  <div className="p-8 sm:p-10">
                    <h3
                      className="text-lg font-semibold leading-8 tracking-tight text-yellow-600"
                      id={tier.id}
                    >
                      {tier.name}
                    </h3>
                    <div className="mt-4 flex items-baseline text-5xl font-bold tracking-tight text-gray-900">
                      {tier.price}zł
                      <span className="text-lg font-semibold leading-8 tracking-normal text-gray-500">
                        / {tier.amount}
                      </span>
                    </div>
                    <p className="mt-6 text-base leading-7 text-gray-600">{tier.description}</p>
                  </div>
                  <div className="flex flex-1 flex-col p-2">
                    <div className="flex flex-1 flex-col justify-between rounded-2xl bg-gray-50 p-6 sm:p-8">
                      <ul role="list" className="space-y-6">
                        {tier.features.map((feature) => (
                          <li key={feature} className="flex items-start">
                            <div className="flex-shrink-0">
                              <CheckIcon className="h-6 w-6 text-yellow-600" aria-hidden="true" />
                            </div>
                            <p className="text-medium ml-3 leading-6 text-gray-600">{feature}</p>
                          </li>
                        ))}
                      </ul>
                      <div className="mt-8">
                        <Link
                          href={tier.href}
                          className="inline-block w-full rounded-lg bg-teal-600 px-4 py-2.5 text-center text-sm font-semibold leading-5 text-white shadow-md hover:bg-teal-700"
                          aria-describedby={tier.id}
                        >
                          {tier.button}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="relative mx-auto mt-8 max-w-7xl px-6 lg:px-8">
          <div className="mx-auto max-w-md lg:max-w-4xl">
            <div className="flex flex-col gap-6 rounded-3xl p-8 ring-1 ring-gray-900/10 sm:p-10 lg:flex-row lg:items-center lg:gap-8">
              <div className="lg:min-w-0 lg:flex-1">
                <h3 className="text-lg font-semibold leading-8 tracking-tight text-yellow-600">
                  Specjalne potrzeby
                </h3>
                <div className="mt-2 text-base leading-7 text-gray-600">
                  Potrzebujesz kilka tysięcy kodów? Chciałbyś dodać kody na jedne tytuł wydanego
                  nakładu?
                </div>
              </div>
              <div>
                <Link
                  href="/contact"
                  className="inline-block rounded-lg bg-teal-50 px-4 py-2.5 text-center text-sm font-semibold leading-5 text-teal-700 hover:bg-teal-100"
                >
                  Napisz <span aria-hidden="true">&rarr;</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
